import React from "react";
import styled from "styled-components";

export const PageTitle = styled.div`
  font-size:24px;
  color:#333333;
`;
export default PageTitle;
